var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "ibox sombra-light" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.puede_activar
          ? _c("div", { staticClass: "alert alert-warning permanent-alert" }, [
              _vm._v(
                "\n                Actualmente el sistema no tiene configurado ningún canal para autenticación de dos factores. Por favor, contacte con un agente si necesita más información.\n            "
              ),
            ])
          : _c("div", [
              _c("div", { staticClass: "ibox-content" }, [
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Two Factor")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group" }, [
                          _c("div", { staticStyle: { padding: "8px" } }, [
                            _vm._v("Desactivar"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user.two_fact,
                                expression: "user.two_fact",
                              },
                            ],
                            staticClass: "js-switch",
                            attrs: {
                              type: "checkbox",
                              "data-switchery": "true",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.user.two_fact)
                                ? _vm._i(_vm.user.two_fact, null) > -1
                                : _vm.user.two_fact,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.user.two_fact,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.user,
                                        "two_fact",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.user,
                                        "two_fact",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.user, "two_fact", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { padding: "8px" } }, [
                            _vm._v("Activar"),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.accion.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _vm.canal_email
                          ? _c("div", { staticClass: "col-md-6" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Email")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-group" }, [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.user.email,
                                        expression: "user.email",
                                      },
                                    ],
                                    staticClass: "form-control ",
                                    attrs: {
                                      placeholder: "Nombre",
                                      type: "text",
                                      disabled: "",
                                    },
                                    domProps: { value: _vm.user.email },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.user,
                                          "email",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canal_telefono
                          ? _c("div", { staticClass: "col-md-6" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Teléfono")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-group" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.user.telefono_celular,
                                        expression: "user.telefono_celular",
                                      },
                                    ],
                                    staticClass: "form-control ",
                                    attrs: {
                                      placeholder: "Teléfono",
                                      type: "text",
                                    },
                                    domProps: {
                                      value: _vm.user.telefono_celular,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.user,
                                          "telefono_celular",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(3),
                  ]
                ),
              ]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("\n                    Two Factor\n                ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        { staticClass: "btn-primary btn", attrs: { type: "submit" } },
        [_vm._v("Guardar")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }